<template>
  <v-container fluid class="pa-0">
    <hero-header page-name="" hero-title="esgIndicators"/>
    <v-container class="my-10 pa-0" fluid>
      <template v-for="(item, index) in esg">
        <v-container :key="index" :class="item.class" fluid>
          <v-container>
            <v-row>
              <v-col cols="12" md="6" lg="4">
                <div class="f58 ont-weight-regular mb-6">
                  {{ item.title[$i18n.locale.substr(0,2)] }}
                </div>
                <div>
                  <v-img :src="require(`../assets/${item.img}`)" aspect-ratio="1" />
                </div>
              </v-col>
              <v-col cols="12" md="6" lg="8">
                <v-row class="mx-4">
                  <template v-for="(set, sindex) in item.sets">
                    <v-col cols="12" :md="set.col" :key="sindex">
                      <v-row align="center">
                        <v-col cols="auto">
                          <v-avatar color="primary" size="36" class="mr-3" tile>
                            <v-icon color="white" size="20">
                              mdi-{{ set.icon }}
                            </v-icon>
                          </v-avatar>
                        </v-col>
                        <v-col cols="cols">
                          <div class="font-weight-bold f22 toUpperCase">
                            {{ set.title[$i18n.locale.substr(0,2)] }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <ul>
                            <template v-for="(li, lindex) in set.cont[$i18n.locale.substr(0,2)]">
                              <li :key="lindex">
                                {{ li }}
                              </li>
                            </template>
                          </ul>
                        </v-col>
                      </v-row>
                    </v-col>
                  </template>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-container>
      </template>
    </v-container>
  </v-container>
</template>

<script>
import heroHeader from '@/components/heroHeader.vue';

export default {
  name: 'ESGGoalsPage',
  components: {
    heroHeader,
  },
  props: {
    //
  },
  async beforeMount() {
    await console.log(this.$i18n.locale);
  },
  data() {
    return {
      esg: [
        {
          title: {
            en: 'Environmental',
            hu: 'Környezeti',
          },
          img: 'esg-env.jpg',
          class: 'mb-10',
          sets: [
            {
              icon: 'tree',
              title: {
                en: 'Energy savings',
                hu: 'Energia megtakarítás',
              },
              cont: {
                en: [
                  'Water supply / consumption', 'Electricity consumption (by installing solar panels)',
                ],
                hu: [
                  'Vízellátás / vízfogyasztás', 'Villamosenergia-fogyasztás (napelemek telepítésével)',
                ],
              },
              col: 6,
            },
            {
              icon: 'recycle',
              title: {
                en: 'Recycling',
                hu: 'Újrahasznosítás',
              },
              cont: {
                en: [
                  'Hazardous material', 'Selective waste collection', 'Mobile equipment refurbish',
                ],
                hu: [
                  'Veszélyes hulladék', 'Szelektív hulladékgyűjtés', 'Mobiltelefon alkatrészek felújítása',
                ],
              },
              col: 6,
            },
            {
              icon: 'note-off',
              title: {
                en: 'Paper-free Business Administration',
                hu: 'Papírmentes iroda',
              },
              cont: {
                en: [
                  'Paperless accounting', 'Official digital signatures',
                ],
                hu: [
                  'Papírmentes könyvelés', 'Digitális aláírás',
                ],
              },
              col: 12,
            },
          ],
        },
        {
          title: {
            en: 'Social',
            hu: 'Társadalmi',
          },
          img: 'esg-soc.jpg',
          class: 'mb-10 light-blue lighten-5',
          sets: [
            {
              icon: 'water-plus',
              title: {
                en: 'Regular blood donation',
                hu: 'Rendszeres véradás',
              },
              cont: {
                en: [
                  'Twice a year', '~20 participant / occasion',
                ],
                hu: [
                  'Évente kétszer', '~20 résztvevő/alkalom',
                ],
              },
              col: 6,
            },
            {
              icon: 'virus-off',
              title: {
                en: 'Maximize COVID safety',
                hu: 'COVID intézkedések',
              },
              cont: {
                en: [
                  'Temperature measurement at entrance',
                  'Ozone generators inside the building',
                  'Providing face masks for all employees',
                  'Home Office where available',
                ],
                hu: [
                  'Testhőmérséklet ellenőrzése belépéskor',
                  'Ózon generátor működtetése minden helységben',
                  'Maszkok biztosítása a munkavállalók számára',
                  'Home Office maximalizálása',
                ],
              },
              col: 6,
            },
            {
              icon: 'human-wheelchair',
              title: {
                en: 'Employment of disabled workers',
                hu: 'Megváltozott munkaképességűek foglalkoztatása',
              },
              cont: {
                en: [
                  'Service, Administration, Contact-center',
                ],
                hu: [
                  'Szerviz, adminisztráció és ügyfélszolgálat területén',
                ],
              },
              col: 6,
            },
            {
              icon: 'handshake',
              title: {
                en: 'Supporting a foundation',
                hu: 'Alapítvány támogatása',
              },
              cont: {
                en: [
                  '\'Camp of Courage\' donation',
                ],
                hu: [
                  'Adomány a Bátor Tábor Alapítvány számára',
                ],
              },
              col: 6,
            },
            {
              icon: 'teddy-bear',
              title: {
                en: 'Kindergarten adoption (East Hungary poor village/ Nyírderzs)',
                hu: 'Örökbefogadott óvodánk (Kelet-Magyarország elmaradottabb térségében/ Nyírderzs)',
              },
              cont: {
                en: [
                  'Quarterly donation', 'Employee and company offerings',
                ],
                hu: [
                  'Adománygyűjtés negyedévente',
                  'Munkavállalói és munkáltatói felajánlások',
                ],
              },
              col: 12,
            },
          ],
        },
        {
          title: {
            en: 'Governance',
            hu: 'Vállalatirányítási',
          },
          img: 'esg-gov.jpg',
          class: 'mb-10',
          sets: [
            {
              icon: 'account-tie',
              title: {
                en: 'Organization Development',
                hu: 'Szervezetfejlesztés',
              },
              cont: {
                en: [
                  'Creating culture of trust, respect, debate and regular feedback',
                  'Dedicated, coordinated, conscious and transparent leadership team',
                  'Agile human resource capacity utilization in production',
                ],
                hu: [
                  'Bizalom, tisztelet, gyakori visszajelzések és a vita kultúrájának megteremtése',
                  'Elkötelezett, jól szervezett, lelkiismeretes és transzparens irányítás',
                  'Mozgatható emberi erőforrás kapacitás kihasználása a termelés területén',
                ],
              },
              col: 6,
            },
            {
              icon: 'file-certificate',
              title: {
                en: 'Accounting and conflicts of interest',
                hu: 'Könyvelés és összeférhetetlenség',
              },
              cont: {
                en: [
                  'Transparent accounting principles and conflicts of interest are provided to the TMX Board by the '
                    + 'Articles of Association and the Decision-making matrix with clear definitions of subject matter '
                    + 'and amount.', 'Annual Deloitte audited financial results',
                ],
                hu: [
                  'Az átlátható számviteli elveket és az összeférhetetlenségeket az Alapszabály és a '
                    + 'Döntéshozatali mátrix biztosítja a TMX Igazgatóság számára.',
                  'Deloitte által évente auditált pénzügyi eredmény',
                ],
              },
              col: 6,
            },
            {
              icon: 'account-group',
              title: {
                en: 'Reduce fluctuation',
                hu: 'Fluktuáció csökkentése',
              },
              cont: {
                en: [
                  'Increasing employee experience', 'Increasing employer value proposition',
                ],
                hu: [
                  'Munkavállalói élmény fokozása',
                  'Munkáltatói márkaépítés',
                ],
              },
              col: 12,
            },
          ],
        },
      ],
    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
